var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"23","width":"4","height":"51","fill":"#9FAEE2","key":0}),React.createElement("rect",{"x":"51","y":"23","width":"4","height":"51","transform":"rotate(90 51 23)","fill":"#9FAEE2","key":1})]);
}

X.defaultProps = {"width":"51","height":"51","viewBox":"0 0 51 51","fill":"none"};

module.exports = X;

X.default = X;
